import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, IconButton } from "@mui/material";
import { useState, type FC } from "react";
import type { PackageImageDTO } from "../../publicPackages/publicPackagesApi";
import { ImageBox } from "../CardImage";
import { packageImageFrameSx, packageImageSx } from "../packageMedia";

interface Props {
  readonly images: PackageImageDTO[];
  readonly onClick: (imageUrl: string) => void;
}

export const ImageCarousel: FC<Props> = ({ images, onClick }) => {
  const [index, setIndex] = useState(0);
  if (images.length === 0) {
    return null;
  }
  // The stored index can outlive the images it was chosen for (the carousel stays mounted while the package
  // changes), so clamp it to the current array instead of trusting it blindly.
  const currentIndex = Math.min(index, images.length - 1);
  return (
    <Box sx={{ ...packageImageFrameSx, borderRadius: 1, height: "auto" }}>
      <ImageBox image={images[currentIndex]} sx={{ ...packageImageSx, cursor: "pointer" }} onClick={onClick} />
      <IconButton
        sx={{
          position: "absolute",
          top: "50%",
          left: 16,
          transform: "translateY(-50%)",
          bgcolor: "rgba(255,255,255,0.8)",
          display: currentIndex > 0 ? "auto" : "none",
        }}
        onClick={() => setIndex(currentIndex - 1)}
      >
        <ChevronLeftIcon />
      </IconButton>
      <IconButton
        sx={{
          position: "absolute",
          top: "50%",
          right: 16,
          transform: "translateY(-50%)",
          bgcolor: "rgba(255,255,255,0.8)",
          display: currentIndex < images.length - 1 ? "auto" : "none",
        }}
        onClick={() => setIndex(currentIndex + 1)}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
};
